// Файл DocumentAttachments.js

/**
 * Компонент объединяет загрузку, список и просмотр вложений.
 * Также он поддерживает скачивание и удаление файлов в карточках.
 */

import { useAccess } from '../../services/AccessContext';

import { useToast } from '../Toast';

import AttachmentList from './document_attachments_parts/AttachmentList';
import AttachmentViewer from './document_attachments_parts/AttachmentViewer';
import use_document_attachments
    from './document_attachments_parts/use_document_attachments';

import './DocumentAttachments.css';
import LoadingIndicator from '../../shared_code/loading';



const DocumentAttachments = ({
    ID_document,
    allowDownload = null,
    emptyText = 'Вложения отсутствуют',
    errorText = 'Не удалось загрузить вложения',
    tableName,
    extraParams = null,
    displayNameOnly = false,
    filesOverride = null,
    filesPdfPathsOverride = null,
    downloadFile = null,
    loadFileBlob = null,
    on_delete = null,
    compact = false,
    canDeleteFile = null,
    refreshKey = 0,
}) => {
    const { hasAccess } = useAccess();
    const { showToast } = useToast();
    const allow_download = allowDownload === null
        ? hasAccess('4.5')
        : Boolean(allowDownload);
    const attachments = use_document_attachments({
        ID_document,
        allow_download,
        displayNameOnly,
        downloadFile,
        errorText,
        extraParams,
        filesOverride,
        filesPdfPathsOverride,
        loadFileBlob,
        refreshKey,
        showToast,
        tableName,
    });
    const display_file_name = (file_name) => (
        displayNameOnly
            ? String(file_name || '').replace(/\\/g, '/').split('/').pop()
            : file_name
    );

    if (attachments.error) {
        return (
            <div className="doc-card__empty doc-card__empty--error">
                {attachments.error}
            </div>
        );
    }

    if (attachments.displayed_files === null) {
        return <div className="doc-card__empty">
                    <LoadingIndicator />
                </div>;
    }

    if (attachments.displayed_files.length === 0) {
        return <div className="doc-card__empty">{emptyText}</div>;
    }

    return (
        <>
            <AttachmentList
                can_delete_file={canDeleteFile}
                compact={compact}
                display_file_name={display_file_name}
                files={attachments.displayed_files}
                on_delete={on_delete || extraParams?.on_delete}
                on_download={allow_download ? attachments.download_file : null}
                on_open={attachments.open_file}
            />
            <AttachmentViewer
                ID_document={ID_document}
                extraParams={extraParams}
                is_open={attachments.isViewerOpen}
                loadFileBlob={loadFileBlob}
                on_close={() => attachments.setIsViewerOpen(false)}
                selected_file={attachments.selectedFile}
                tableName={tableName}
            />
        </>
    );
};


export default DocumentAttachments;
